import { render } from "./CapturaFoto.vue?vue&type=template&id=8bb512ca&scoped=true"
import script from "./CapturaFoto.vue?vue&type=script&lang=js"
export * from "./CapturaFoto.vue?vue&type=script&lang=js"

import "./CapturaFoto.vue?vue&type=style&index=0&id=8bb512ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb512ca"]])

export default __exports__